import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoaderService } from '../../../../shared/services/loader.service';

interface WizardStep {
  title: string;
  description: string;
  route: string;
  minHeight?: number;
}

@Component({
    selector: 'app-wizard-menu',
    imports: [CommonModule],
    templateUrl: './wizard-menu.component.html',
    styleUrl: './wizard-menu.component.scss'
})
export class WizardMenuComponent implements OnInit {
  currentStep = 1;
  steps: WizardStep[] = [
    { title: 'Dentist information', description: 'Information for identification', route: '/credentialing/information' },
    {
      title: 'Dental credentials',
      description: 'Licenses, certifications and qualifications',
      route: '/credentialing/credentials',
      minHeight: 86
    },
    { title: 'Work/Education history', description: 'Work or School information', route: '/credentialing/work-history' },
    {
      title: 'Attestations',
      description: 'Attest and sign professional information',
      route: '/credentialing/attestations',
      minHeight: 86
    },
    { title: 'Locations', description: 'Manage participating locations', route: '/credentialing/locations' },
    { title: 'Documents', description: 'Sign all applicable documentation', route: '/credentialing/sign-documents' },
    {
      title: 'Confirmation',
      description: 'Verify and submit credentialing application',
      route: '/credentialing/confirmation',
      minHeight: 86
    }
  ];

  constructor(private router: Router, private loader: LoaderService) { }

  ngOnInit() {
    this.updateCurrentStep(this.router.url);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateCurrentStep(event.url);
      this.loader.hide();
    });
  }

  private updateCurrentStep(url: string) {
    if (url.endsWith('/wizard') || url.includes('information')) this.currentStep = 1;
    else if (url.includes('credentials')) this.currentStep = 2;
    else if (url.includes('work-history')) this.currentStep = 3;
    else if (url.includes('attestations')) this.currentStep = 4;
    else if (url.includes('locations')) this.currentStep = 5;
    else if (url.includes('sign-documents')) this.currentStep = 6;
    else if (url.includes('confirmation')) this.currentStep = 7;
  }

  toggleStep(index: number) {
    const step = this.steps[index];
    if (!step || this.router.url === step.route) {
      return;
    }

    this.loader.show();
    this.router.navigate([step.route]);
  }
}
